import { Injectable } from '@angular/core';
import { PlaidLinkHandler } from 'ngx-plaid-link/lib/ngx-plaid-link-handler';
import { NgxPlaidLinkService } from 'ngx-plaid-link';
import { environment } from '../../../environments/environment';
import { MainService } from '../main/main.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ContractDialogComponent } from 'src/app/pages/contract/contract-modal/contract-modal.component';
import { getUserProfile } from 'src/app/core/session';

@Injectable({
  providedIn: 'root'
})
export class PlaidService {
  patient_id = 0;
  doctor_id = 0;
  private plaidLinkHandler: PlaidLinkHandler;
  private plaidConfig = {
    apiVersion: "v2",
    env: environment.production ? 'production' : 'sandbox',
    product: ["auth"],
    clientName: "Denefits",
    key: environment.plaid_public_key,
    selectAccount: true,
    countryCodes: ['US']
  };
  public plaid_data: any;
  public plaid_error_subject: Subject<any> = new Subject();
  public patient_balance: BehaviorSubject<any> = new BehaviorSubject(0);
  public plaid_success_subject: Subject<any> = new Subject();
  plaid_reauthenticate: any = 0;
  constructor(public mainService: MainService,
    private plaidLinkService: NgxPlaidLinkService,
    private _router: Router,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
  }

  openPlaidHandler(data?) {
    this.plaid_data = data ? data : { plaid_token: localStorage.getItem('plaid_token') };
    this.plaidConfig['token'] = this.plaid_data.plaid_token;
    if (data.receivedRedirectUri) {
      this.plaidConfig['receivedRedirectUri'] = data.receivedRedirectUri;
    } else if (this.plaidConfig['receivedRedirectUri']) {
      this.plaidConfig['receivedRedirectUri'] = null;
    }
    console.log('this.plaidConfig', this.plaidConfig);
    this.plaidLinkService
      .createPlaid(
        Object.assign({}, this.plaidConfig, {
          onSuccess: (token, metadata) => this.onSuccess(token, metadata),
          onExit: (error, metadata) => this.onExit(error, metadata)
          // onEvent:(eventName, metadata) => this.onEvent(eventName, metadata)
        })
      )
      .then((handler: PlaidLinkHandler) => {
        this.plaidLinkHandler = handler;
        this.open();
      });
  }

  open() {
    this.plaidLinkHandler.open();
  }

  onEvent(token, metadata) {
  }

  onSuccess(token, metadata) {
    this.createStripeTokenThroughPlaid(token, metadata);
  }


  onExit(err, metadata) {
    if (err != null) {
      if (err.error_type == "ITEM_ERROR" || err.error_type == "INVALID_REQUEST" || err.error_type == "INVALID_INPUT" || err.error_type == "RATE_LIMIT_EXCEEDED" || err.error_type == "API_ERROR" || err.error_type == "AUTH_ERROR" || err.error_type == "ASSET_REPORT_ERROR" || err.error_type == "INSTITUTION_ERROR") {
        this.mainService.customPopups((err.display_message || err.error_message), 1);
        this.plaidError(err, metadata);
      } else {
        this.mainService.customPopups('No data found', 1);
        this.plaidError(err, metadata);
      }
    }
    if (metadata && metadata.status && metadata.status == 'institution_not_found') {
      this.mainService.customPopups('Bank not found', 1);
      this.plaidError(metadata, metadata);
    }
  }

  plaidError(err, metadata) {
    let params = {
      error: JSON.stringify(err),
      metadata: JSON.stringify(metadata),
      access_token: localStorage.getItem('token'),
    }
    if (this.plaid_data && this.plaid_data.patient_id > 0 && this.plaid_data.patient_id != null) {
      params['patient_id'] = this.plaid_data.patient_id;
    } else if (this.plaid_data && this.plaid_data.doctor_id > 0 && this.plaid_data.doctor_id != null) {
      params['doctor_id'] = this.plaid_data.doctor_id;
    }
    this.mainService.api(params, 'plaid_error', true)
      .subscribe((data: any) => {
        if (data.is_error == 1) {
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, 1);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        } else {
          if (!(err != null || metadata && metadata.status && metadata.status == 'institution_not_found')) {
            this.mainService.customPopups('Please try again later', 1);
          }
        }
        this.plaid_error_subject.next(err);
      }, (error: any) => {
        console.log(error);
      });

  }

  createStripeTokenThroughPlaid(token, metadata) {
    let params = {
      public_token: token,
      account_id: metadata.account_id,
      metadata: JSON.stringify(metadata),
      access_token: localStorage.getItem('token'),
      type: 0,
      doctor_id: localStorage.getItem('userProfileData') ? getUserProfile()['doctor_id'] : 0
    }
    if (this.plaid_data && this.plaid_data.patient_id > 0 && this.plaid_data.patient_id != null) {
      params['patient_id'] = this.plaid_data.patient_id;
    } else if (this.plaid_data && this.plaid_data.doctor_id > 0 && this.plaid_data.doctor_id != null) {
      params['doctor_id'] = this.plaid_data.doctor_id;
    }
    if (metadata && metadata.account && metadata.account.verification_status == 'pending_manual_verification') {
      params['type'] = 1;
    } else if (this.plaid_reauthenticate == 1) {
      params['type'] = 2;
    }
    if (this.userInfo['type'] == 6) {
      params['card_desired_amount'] = this.userInfo['card_desired_amount'] || 0;
      params['bank_desired_amount'] = this.userInfo['bank_desired_amount'] || 0;
    }
    this.mainService.api(params, 'bank_token_through_plaid', false)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.mainService.customPopups('Bank Added Successfully.', 0);
          this.authService.accessTokenLogin();
          this.plaid_success_subject.next(1);
          setTimeout(() => {
            //To add bank account
            this.dialog.open(ContractDialogComponent, {
              width: '500px',
              panelClass: 'rightFullDialog',
              data: {
                type: 56,
                title: 'Add Bank'
              }
            });
          }, 1000);
        }
        if (data.is_error == 1) {
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, 1);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        }
      }, (error: any) => {
        console.log(error);
      });
  }
  userInfo = {};
  createLinkTokenPlaid(userInfo) {
    const params = {
      access_token: localStorage.getItem('token'),
      doctor_id: userInfo.doctor_id,
      redirect_url: environment.plaid_redirect_url,
      link_type: 2,
      public_token: userInfo.plaid_access_token
    };
    this.userInfo = userInfo;
    this.mainService.api(params, 'create_link_token_plaid', false)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          let token_data = {};
          token_data['plaid_token'] = data.data.link_token;
          token_data['doctor_id'] = userInfo.doctor_id;
          localStorage.setItem('plaid_token', data.data.link_token);
          if (userInfo && userInfo.status == 'reauthenticate') {
            this.plaid_reauthenticate = 1;
          }
          // this.openPlaidHandler(token_data);
          this.openPlaidHandler(token_data);
        }
        if (data.is_error == 1) {
          if (data.override_text || data.err) {
            this.mainService.customPopups(data.override_text || data.err, 1);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        }
      }, (error: any) => {
        console.log(error);
      });
  }
}
